import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./Support.css";
import {
  Row,
} from "react-bootstrap";

export default class ContactUs extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      user: props.user,
      isLoading: true,
    };
  }
  
  render() {

    return (
      <div>
        <div key="menubar" className="home">
          <Navbar.Header>
            <Navbar.Brand>
              <NavLink to="/">
                <img className="brand-image" alt="AutoAuth" src='img/AutoAuth-transparent-TM.png' />
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Row key="welcome" className="panel shopTable">
            <div className="text-center">Contact Us - Coming Soon</div>
          </Row>
          
        </div>
      </div>
    );
  }
}